import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { PropertyService } from '../../../../features/property/services/property.service';
import { State, US_STATES } from '../../models/us-states.model';
import { catchError, map, of, shareReplay } from 'rxjs';
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from '@angular/material/select';
import { ScrollProgressDirective } from "../../directives/scroll-progress.directive";
import { HorizinnsLoader } from '../horizinns-loader/horizinns-loader';
import { Confetti } from "../confetti/confetti";
import { GlassPillDirective } from '../../directives/glass-pill.directive';
import { HapticsService } from '../../services/haptics.service';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';
import { FeaturedGlobeComponent } from "../../../../features/property/components/featured-globe/featured-globe.component";

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatFormField,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatListModule,
    ScrollProgressDirective,
    HorizinnsLoader,
    Confetti,
    GlassPillDirective,
    FeaturedGlobeComponent
],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class HomeComponent implements OnInit {
  private haptics = inject(HapticsService);

  private gtm = inject(GtmService);
  searchText = '';
  private propertyService = inject(PropertyService);
  private router = inject(Router);
  private seo = inject(SeoService);
  platformId = inject(PLATFORM_ID);

  states: State[] = US_STATES;

  activeStates$ = this.propertyService.getActivePropertyStates().pipe(
    map((codes: string[]) =>
      this.states.filter(s => codes.includes(s.code))
    ),
    catchError(err => {
      console.error('Failed to load active states:', err);
      return of([]);
    }),
    shareReplay(1)
  );

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0; 
      
      this.gtm.pageView({
        page_path: '/',
        page_title: 'Horizinns'
      });

    }
    this.seo.updateMetaTags(
      'Horizinns', 
      'Stop overpaying—book direct and slash fees! No Airbnb/VRBO service charges means more money for cocktails (or upgrades). Find your ideal getaway with honest owners today.',
      `${environment.appUrl}/assets/images/horizinns-cover.jpg`,
      `${environment.appUrl}`);

    this.seo.addJsonLd({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Horizinns",
      "description": "Stop overpaying—book direct and slash fees! No Airbnb/VRBO service charges means more money for cocktails (or upgrades). Find your ideal getaway with honest owners today.",
      "url": "${environment.appUrl}"
    });
  }

  go() {
    this.router.navigate(['/property']);
  }

  getResults() {
    this.haptics.click();
    console.log('getResults', this.searchText);
    if (this.searchText) {
      this.router.navigate(['/property'], {
        queryParams: { state: this.searchText }
      });
    } else {
      this.router.navigate(['/property']);
    }
  }

  select() {
    this.haptics.click();
  }
}
